var render = function render(){var _vm=this,_c=_vm._self._c;return _c('viewer',{attrs:{"images":_vm.images}},_vm._l((_vm.images),function(item,index){return _c('img',{key:index,staticStyle:{"height":"100%","width":"100%","border-radius":"10%","object-fit":"cover"},attrs:{"src":item,"alt":""}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }